export const plans = {
  // "$0.00": {
  //   name: "Free plan",
  //   limit: "2k word limit",
  //   price: "$0.00",
  //   wordsLimit: 2000,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: false,
  //   code: "price_1LfMAoHUtEEoDk2UkRPDJzjN",
  // },
  // "$19.99": {
  //   name: "Free plan",
  //   limit: "20k word limit",
  //   price: "$19.99",
  //   wordsLimit: 20000,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: false,
  //   // code: "price_1LfMAoHUtEEoDk2UkRPDJzjN",
  // },
  // "$29.99": {
  //   name: "Standard plan",
  //   limit: "20k word limit",
  //   price: "$29.99",
  //   amount: 29.99,
  //   wordsLimit: 20000,
  //   isAnnually: false,
  //   code: "price_1LFyujHUtEEoDk2UuvTGpSv9",
  // },
  // "$228.00": {
  //   name: "Standard plan",
  //   limit: "20k word limit",
  //   price: "$19.00",
  //   amount: 228.00,
  //   wordsLimit: 20000,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: true,
  //   code: "price_1LfMdmHUtEEoDk2Ua2yfUWVN",
  // },

  // "$397.00": {
  //   name: "Standard plan",
  //   limit: "20k word limit",
  //   price: "$397.00",
  //   amount: 397.00,
  //   wordsLimit: 20000,
  //   isAnnually: true,
  //   code: "standard-plan-yearly-397",
  // },
  "$49.00": {
    name: "Standard plan",
    limit: "30k word limit",
    price: "$49.00",
    amount: 49.00,
    wordsLimit: 60000,
    isAnnually: false,
    // code: "standard-plan-monthly-49",
    // code: "creator-copy-pro-monthly-49",
    code: "price_1QFsEZJotKJS6JVSqeaN6Xgn",
  },
  "$470.00": {
    name: "Standard plan",
    limit: "30k word limit",
    price: "$470.00",
    amount: 470.00,
    wordsLimit: 60000,
    isAnnually: true,
    // code: "creator-copy-pro-yearly-470",
    code: "price_1QFsJNJotKJS6JVSZFAGcpK8",
  },
  // "$69.00": {
  //   name: "Pro plan",
  //   limit: "50k word limit",
  //   price: "$69.00",
  //   wordsLimit: 50000,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: false,
  //   code: "price_1LfMuiHUtEEoDk2UjpgAxLkp",
  // },
  // "$59.00" : {
  //   name: "Pro plan",
  //   limit: "350k+ word limit",
  //   price: "$59.00",
  //   wordsLimit: 1,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: false,
  // },
  // "$99.00": {
  //   name: "Pro plan",
  //   limit: "100k word limit",
  //   price: "$99.00",
  //   wordsLimit: 100000,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: false,
  //   code: "price_1LfMvMHUtEEoDk2UpXFOsOpY",
  // },
  // "$249.00": {
  //   name: "Pro plan",
  //   limit: "350k+ word limit",
  //   price: "$249.00",
  //   wordsLimit: 1,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: false,
  //   code: "price_1LfMw9HUtEEoDk2Umz9P7u7N",
  // },
  // "$660.00": {
  //   name: "Pro plan",
  //   limit: "50k word limit",
  //   price: "$55.00",
  //   wordsLimit: 50000,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: true,
  //   code: "price_1LfN84HUtEEoDk2UwMP7PAZw",
  // },
  // "$948.00": {
  //   name: "Pro plan",
  //   limit: "100k word limit",
  //   price: "$79.00",
  //   wordsLimit: 100000,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: true,
  //   code: "price_1LfN8OHUtEEoDk2UZtkOvZwV",
  // },
  // "$2,388.00": {
  //   name: "Pro plan",
  //   limit: "350k+ word limit",
  //   price: "$199.00",
  //   wordsLimit: 1,
  //   // code: "price_1JiYXQJotKJS6JVSttXRhvj3",
  //   isAnnually: true,
  //   code: "price_1LfN8jHUtEEoDk2UPC823Nvi",
  // },
};
